export const categories = ["Beef", "Pork", "Chicken", "Fish", "Other Meats", "Vegetarian", "Salads", "Sides", "Dessert", "Breads", "Sauces", "Breakfast", "Drinks", "Soups"];

export const cuisines = ["Middle Eastern", "Turkish", "American", "Italian", "Mexican", "Indian", "Asian", "South American", "Irish", "Korean", "Chinese", "Belgian"];

export function toSlug(name) {
  return name.toLowerCase().trim().replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-');
}

export function findRecipeBySlug(slug) {
  return recipes.find(r => toSlug(r.name) === slug);
}

export const recipes = [{
  name: "Pulled Pork",
  description: "Dutch-oven pulled pork rubbed with brown sugar and smoked paprika, braised low and slow, then tossed in a tangy ketchup-mustard barbecue sauce.",
  image: "/images/recipes/pulled-pork.jpg",
  prepTime: "20 min",
  cookTime: "5 hr",
  totalTime: "5 hr 20 min",
  servings: 8,
  cuisine: "American",
  category: "Pork",
  tags: ["pork", "bbq", "braised", "sandwiches"],
  ingredients: [
    "**For the pork:**",
    "4 lbs boneless pork butt",
    "3 tbsp packed dark brown sugar",
    "1 tbsp kosher salt",
    "1 tbsp smoked paprika",
    "1 tsp garlic powder",
    "1 tsp onion powder",
    "1 tsp ground cumin",
    "Freshly ground black pepper",
    "2 tbsp vegetable oil",
    "12 oz Coca-Cola or root beer (alternatively: ½ cup apple cider vinegar & 1 cup apple juice)",
    "**For the BBQ Sauce:**",
    "1½ cups ketchup",
    "⅓ cup apple cider vinegar",
    "½ cup Dijon mustard",
    "¼ cup packed dark brown sugar",
    "2 tbsp Worcestershire sauce",
    "Toasted buns, for serving",
  ],
  instructions: [
    "Preheat the oven to 300°F. Trim excess fat from the pork and cut it into large pieces that will fit in a Dutch oven.",
    "In a small bowl, combine brown sugar, salt, paprika, garlic powder, onion powder, and cumin, then season with black pepper. Rub all over pork *(this can be done the night before)*.",
    "In a large Dutch oven over medium-high heat, heat oil. Working in batches, add pork and sear on all sides. (Spices can burn quickly so don't let it go for too long!)",
    "Pour coke/root beer around the pork and cover with lid. Transfer to oven and cook until pork is beginning to turn tender, about 3 hours. *Check after 2 hours - this may be done sooner* Remove lid and cook until pork is very tender and pulls apart easily with a fork, 1-2 hours more.",
    "Remove pork from Dutch oven and let rest while you prepare barbecue sauce.",
    "Make barbecue sauce: To the pan drippings in the Dutch oven, whisk in ketchup, apple cider vinegar, mustard, brown sugar, and Worcestershire. Over medium-high heat, bring mixture to a boil. Reduce heat, and simmer until thickened slightly, about 5 minutes.",
    "Shred the pork using two forks. *Immediately after shredding, drain and move to a bowl. If you leave the shredded meat in the juices, it will waterdown the BBQ sauce when you add it.* Toss shredded meat with about half the barbecue sauce.",
    "Serve warm with buns and more barbecue sauce",
  ],
  notes: null,
  source: "https://www.delish.com/cooking/recipe-ideas/a58254/best-pulled-pork-recipe/",
},
{
  name: "Creamy Pesto Baked Gnocchi and Chicken Skillet",
  description: "A one-skillet bake of seared chicken, gnocchi, and grape tomatoes finished with pesto and melted mozzarella.",
  image: "/images/recipes/chicken-gnocchi.jpg",
  prepTime: "15 min",
  cookTime: "35 min",
  totalTime: "50 min",
  servings: 4,
  cuisine: "Italian",
  category: "Chicken",
  tags: ["chicken", "gnocchi", "pesto", "skillet", "one-pan"],
  ingredients: [
    "3 boneless, skinless chicken breasts (about 1½ lbs total)",
    "Kosher salt",
    "Freshly ground black pepper",
    "2 tbsp extra-virgin olive oil, divided",
    "½ small yellow onion, thinly sliced",
    "2 cloves garlic, thinly sliced",
    "1½ cups grape tomatoes, halved",
    "¼ cup dry white wine *or water/broth*",
    "1 cup low-sodium chicken broth",
    "2 tbsp heavy cream",
    "1 (17 oz) package gnocchi",
    "½ cup pesto, divided",
    "6 oz mozzarella, torn (fresh is best!)",
    "Fresh basil and toasted pine nuts, for serving",
  ],
  instructions: [
    "Preheat oven to 425°F. Season chicken on both sides with 3/4 teaspoon salt and 1/4 teaspoon pepper. In a large straight-sided skillet over medium-high heat, heat 1 tablespoon oil. Add chicken and cook, turning occasionally, until almost fully cooked. Transfer to a plate.",
    "In the same skillet over medium heat, heat remaining 1 tablespoon oil. Add onion and garlic and cook, stirring occasionally, until tender, 3 to 5 minutes. Add tomatoes and wine and cook, stirring and scraping up any brown bits on bottom of pan, until wine is mostly evaporated and tomatoes are just starting to wilt, about 2 minutes. Pour in broth and cream and bring to a boil. Stir in gnocchi and nestle chicken back into pan.",
    "Bake until chicken is cooked through and instant-read thermometer inserted into thickest part registers 165°F, 8 to 10 minutes. Transfer chicken to a cutting board.",
    "Stir 2 tablespoons pesto into skillet. Top with mozzarella (if using). Continue to bake until pesto is warmed through and cheese is melted, about 4 minutes more. Let cool slightly.",
    "Thinly slice chicken and return to skillet. Dollop top of bake with remaining 6 tablespoons pesto. Sprinkle with basil and pine nuts.",
  ],
  notes: null,
  source: "https://www.delish.com/cooking/recipe-ideas/a41915964/creamy-pesto-baked-gnocchi-and-chicken-skillet-recipe/",
},
{
  name: "Garlic Brown Sugar Glazed Salmon",
  description: "Salmon baked in foil with a garlicky honey-brown sugar glaze, then broiled until caramelized.",
  image: "/images/recipes/brown-sugar-salmon.jpg",
  prepTime: "5 min",
  cookTime: "25 min",
  totalTime: "30 min",
  servings: 4,
  cuisine: "American",
  category: "Fish",
  tags: ["salmon", "seafood", "garlic", "weeknight", "gluten-free"],
  ingredients: [
    "2 lbs salmon",
    "2 tbsp olive oil",
    "¼ cup brown sugar",
    "¼ cup soy sauce",
    "2 tbsp unsalted butter (optional)",
    "¼ cup honey",
    "5 cloves garlic, minced",
    "2 tbsp stone ground mustard",
    "Zest of 1 orange",
    "Juice of 1 lemon",
    "¼ cup orange juice",
    "Salt and pepper, to taste",
  ],
  instructions: [
    "Preheat oven to 350°F",
    "Line a baking sheet with aluminum foil and transfer the fish into it with the skin side down. Sprinkle with salt and pepper.",
    "Fold up the sides of the aluminum foil around the salmon",
    "In a medium bowl, whisk together all the ingredients except butter. Pour the glaze over the salmon and then spread the butter over the fish",
    "Top the salmon with aluminum foil and seal",
    "Transfer the dish to the oven and bake for about 20-25 minutes. Keep an eye on it not to overcook it",
    "Lastly, uncover the foil off of the top and baste the salmon with some more sauce and butter and put on broil. Broil for 2-3 minutes or until brown and caramelized.",
  ],
  notes: "Don't 'drown' in sauce. Just pour a bit on each fillet, then check often during cooking to add more. Possibly also shorten cooking time (slightly) and lengthen broil time to get sauce to carmelize better",
  source: "https://sweetandsavorymeals.com/garlic-brown-sugar-glazed-salmon/",
},
{
  name: "Creamy Vegan Mushroom Risotto",
  description: "A dairy-free, gluten-free mushroom risotto that's still rich and creamy thanks to nutritional yeast and a good mantecatura finish.",
  image: "/images/recipes/vegan-mushroom-risotto.jpg",
  prepTime: "10 min",
  cookTime: "30 min",
  totalTime: "40 min",
  servings: 2,
  cuisine: "Italian",
  category: "Vegetarian",
  tags: ["vegan", "gluten-free", "mushroom", "vegetarian", "comfort food"],
  ingredients: [
    "1 tbsp olive oil",
    "1 shallot (or ½ white onion), diced",
    "3 cloves garlic, minced",
    "100g button mushrooms, thinly sliced",
    "100g (~½ cup) risotto rice",
    "500ml (~2 cups) vegetable stock",
    "½ tbsp white wine vinegar (optional)",
    "2 tbsp nutritional yeast flakes (optional)",
    "Fresh parsley, to serve",
    "Salt and pepper, to taste",
  ],
  instructions: [
    "Heat the olive oil in a large saute pan. Add the shallot and garlic and cook on a medium-low heat until softened.",
    "Add the mushrooms and cook for a further minute",
    "Stir in the risotto rice and immediately pour in the stock and vinegar (if using). Bring to a boil, then reduce to a simmer (covered) for approximately 30 minutes, or until all the liquid has been absorbed and the rice is cooked. Add more hot water, if necessary",
    "Once cooked, stir in the nutritional yeast (if using), stir in a handful of chopped fresh parsley and season with salt and pepper.",
  ],
  notes: null,
  source: "https://wallflowerkitchen.com/creamy-mushroom-risotto-vegan-gf/",
},
{
  name: "Chewy English Toffee Cookies",
  description: "Tender, chewy, buttery cookies loaded with English toffee bits.",
  image: "/images/recipes/toffee-cookies.jpg",
  prepTime: "15 min",
  cookTime: "10 min",
  totalTime: "25 min",
  servings: 30,
  cuisine: "American",
  category: "Dessert",
  tags: ["cookies", "baking", "toffee", "dessert"],
  ingredients: [
    "2¼ cups all-purpose flour",
    "1 tsp baking soda",
    "½ tsp salt",
    "½ cup salted butter, softened",
    "¾ cup granulated sugar",
    "¾ cup light brown sugar, packed",
    "1 tsp vanilla extract",
    "2 large eggs, room temperature",
    "1 (8 oz) bag toffee bits",
  ],
  instructions: [
    "Preheat the oven to 350°F. Place a silicone baking mat or parchment paper on a baking sheet.",
    "Stir together the flour, baking soda, and salt. Set aside.",
    "Using a mixer, beat the butter, sugars, and vanilla until creamy. Add the eggs and blend thoroughly.",
    "Gradually add the flour mixture to the sugar mixture. Beat until incorporated",
    "Stir in the toffee bits.",
    "Use a 1½-inch cookie scoop (a little smaller than the size of a golf ball - or maybe half a golf ball) to measure the dough. Drop it onto the prepared baking sheet, leaving room for the cookies to spread.",
    "Bake for 9-11 minutes or until the cookies are lightly browned (wait until the edges start to brown. The cookies will NOT look \"flat\" & \"cracked\" until they cool). Let the cookies cool for a few minutes (~5 minutes). THen move them to a cooling rack. Store them in an airtight container on the countertop or freeze them. They will taste fresh for about 3 days when kept on a countertop.",
  ],
  notes: null,
  source: "https://www.thehouseofelynryn.com/2023/12/21/chewy-english-toffee-cookies/",
},
{
  name: "Lobster Ravioli Pink Sauce",
  description: "A quick creamy tomato sauce for store-bought lobster ravioli — ready in 15 minutes.",
  image: "/images/recipes/pink-sauce.jpg",
  prepTime: "5 min",
  cookTime: "10 min",
  totalTime: "15 min",
  servings: 2,
  cuisine: "Italian",
  category: "Sauces",
  tags: ["pasta", "seafood", "quick", "sauce"],
  ingredients: [
    "1 tbsp unsalted butter",
    "1 small shallot, finely diced",
    "4 cloves garlic, pressed",
    "¼ tsp dried thyme",
    "¼ tsp dried oregano",
    "¼ tsp dried basil",
    "½ tsp salt",
    "Fresh cracked pepper",
    "¼ cup dry white wine",
    "½ cup crushed tomatoes",
    "1 tbsp lemon juice",
    "Zest of ½ lemon (optional)",
    "½ cup heavy cream",
    "¼ cup grated parmesan",
  ],
  instructions: [
    "In a skillet, heat the butter over medium heat. Add the shallot and garlic. Sauté until browned.",
    "Stir in the dried herbs, salt, and pepper. Sauté for about 1 minute or until fragrant.",
    "Deglaze the pan with the white wine, scraping any bits off the bottom.",
    "Add the crushed tomatoes, lemon juice, and lemon zest.",
    "Turn the heat to medium low. Stir in the cream and parmesan cheese. Bring to a simmer and then turn off the heat.",
    "Toss the lobster ravioli in the sauce and serve with fresh basil and parmesan on top.",
  ],
  notes: null,
  source: "https://biteswithbri.com/lobster-ravioli-sauce/",
},
{
  name: "Authentic Chimichurri",
  description: "A vibrant, herby oil-based condiment from Uruguay and Argentina, traditionally spooned over grilled meats.",
  image: "/images/recipes/chimichurri.jpg",
  prepTime: "10 min",
  cookTime: "0 min",
  totalTime: "10 min",
  servings: 8,
  cuisine: "South American",
  category: "Sauces",
  tags: ["sauce", "condiment", "grilling", "no-cook", "vegan"],
  ingredients: [
    "½ cup olive oil",
    "1 tbsp red wine vinegar",
    "½ cup parsley, finely chopped",
    "1½ - 2 cloves garlic, finely chopped",
    "1 small red chili, deseeded and finely chopped",
    "½ tsp dried oregano",
    "½ tsp coarse salt",
    "¼ tsp black pepper",
  ],
  instructions: [
    "Mix all ingredients together in a bowl. Allow to sit for 5-10 minutes to release all of the flavors into the oil before using. Ideally, let it sit for more than 2 hours, if time allows.",
    "Chimichurri can be prepared earlier than needed, and refrigerated for 24 hours, if needed.",
    "Use to baste meats (chicken or steaks) while grilling or barbecuing. We don't use it as a marinade, but choose to baste our meats with chimichurri instead. However, you can use it as a marinade if you wish. Also, add a couple of tablespoons over your steak to serve.",
  ],
  notes: null,
  source: "https://cafedelites.com/authentic-chimichurri-uruguay-argentina/",
},
{
  name: "Easy No-Fuss Thanksgiving Turkey",
  description: "A foolproof roast turkey with an herb butter rubbed under the skin, no basting required.",
  image: "/images/recipes/thanksgiving-turkey.jpg",
  prepTime: "20 min",
  cookTime: "3 hr 30 min",
  totalTime: "3 hr 50 min",
  servings: 16,
  cuisine: "American",
  category: "Other Meats",
  tags: ["turkey", "holiday", "roast", "thanksgiving"],
  ingredients: [
    "1 turkey (12-20 lbs)",
    "1 onion, peeled and quartered",
    "1 lemon, quartered",
    "1 apple, quartered",
    "¾ oz fresh rosemary",
    "¾ oz fresh thyme",
    "¾ oz fresh sage",
    "**For the herb butter:**",
    "1 cup unsalted butter, softened",
    "1 tsp salt",
    "½ tsp freshly ground black pepper",
    "6-8 cloves garlic, minced",
    "*some of the above herbs, chopped*",
  ],
  instructions: [
    "If the turkey is frozen: thaw in the fridge, 24 hours for every 5 pounds of turkey. I like to give myself 1 extra day, just to be safe.",
    "Remove the thawed turkey from the fridge 1 hour before roasting, to let it come to room temperature.",
    "Adjust your oven rack so the turkey will sit in the center of the oven. Preheat the oven to 325°F.",
    "Make the herb butter by combining room temperature butter, minced garlic, salt, pepper, one tablespoon fresh chopped rosemary, one tablespoon fresh chopped thyme, and one tablespoon fresh chopped sage (you'll use the remaining fresh herbs for stuffing inside the cavity of the turkey).",
    "Remove turkey from packaging and remove the neck and giblets from inside the cavities of the bird (reserve them for gravy, if you want, or discard them). Pat the turkey very dry with paper towels.",
    "Season the cavity of the turkey with salt and pepper. Stuff it with the quartered lemon, onion, apple, and the remaining fresh herbs.",
    "Use your fingers to loosen and lift the skin above the breasts (on top of the turkey) and smooth a few tablespoons of the herb butter underneath.",
    "Tuck the wings of the turkey underneath the turkey and set the turkey on a roasting rack inside a roasting pan.",
    "Microwave the remaining herb butter mixture for 30 seconds (it doesn't need to be completely melted - just really softened). Use a basting brush to brush the remaining herb butter all over the outside of the turkey, legs, and wings.",
    "Roast at 325°F for about 13-15 minutes per pound, or until internal temperature (inserted on middle of thigh and breast) reaches about 165°F.",
    "Check the turkey about halfway through cooking, and once the skin gets golden brown, cover the top of the turkey with tinfoil, to protect the breast meat from overcooking. Alternatively, you could start cooking the turkey with it tented in foil, then during the last hour or so of cooking you can take the foil off to let the turkey brown.",
    "Allow turkey to rest 20-30 minutes before carving",
    "Reserve any drippings and juice remaining in your roasting pan to make turkey gravy",
  ],
  notes: null,
  source: "https://tastesbetterfromscratch.com/easy-no-fuss-thanksgiving-turkey/",
},
{
  name: "Turkey Gravy",
  description: "A simple pan gravy built from roast turkey drippings and a flour roux.",
  image: "/images/recipes/turkey-gravy.jpg",
  prepTime: "10 min",
  cookTime: "10 min",
  totalTime: "20 min",
  servings: 15,
  cuisine: "American",
  category: "Sauces",
  tags: ["gravy", "holiday", "thanksgiving", "sauce"],
  ingredients: [
    "Drippings from roasted turkey",
    "½ cup all-purpose flour",
    "4 cups low-sodium chicken broth (or turkey or vegetable broth)",
    "Salt and pepper, to taste",
    "Turkey giblets and neck (optional)",
  ],
  instructions: [
    "Place the neck, heart, liver, and gizzards of the turkey inside a medium size saucepan. Cover the giblets completely with water and bring the water to a boil. Once boiling, simmer for 1 hour or until the meat is cooked through.",
    "Next, use a slotted spoon to remove the giblets from the water and set aside. At this point you can decide to discard the liquid from the giblet water or save a little of it to use at the very end of making your gravy if you need to make the gravy thinner. Otherwise, you don't need this liquid.",
    "Once the giblets have cooled, remove the libers and discard them (they add a realy strong taste and flavor not many people like). Use your fingers to remove any meat from the turkey neck. Add the meat to the rest of the giblets and discard what's left of the neck. Then dice the giblets into small pieces and reserve them for the gravy.",
    "When you have taken your turkey out of the oven, pour the drippings (what's left in the roasting pan after cooking the turkey - this includes the fat that has melted and any bits of meat that have fallen off) from your turkey roasting pan into a large bowl. (Tip the pan away from your body and be careful not to burn yourself)",
    "Now let the drippings sit for a minute, allowing the fat to naturally separate from the rest of the drippings. You will notice that the fat will rise to the top, leaving the drippings and liquid on the bottom. Use a large spoon or ladle to skim (remove) most of the fat from the top of the drippings.",
    "To make the gravy, use a large sauce pan and add 1 cup of drippings to the pan",
    "Add 1/2 cup flour to the pan and whisk together until it makes a smooth paste. (at this point you'll need to use a little of your own judgement. You want a pasty consistency. If yours seems a little greasy, add more flour)",
    "When you have found the right consistency, whisk the mixture slowly over the heat as it begins to brown. You are creating a roux.",
    "Once you get a nice golden brown color, add 4 cups of chicken broth and 1 additional cup of drippings.",
    "Allow the gravy to cook, whisking constantly for about 5 to 8 minutes, or until thickened. Then add the giblet meat.",
    "At this point, decide for yourself if you like the consistency of the gravy. If the gravy is too thick, add the giblet broth or drippings. If gravy is too thin, cook for about 10 minutes. If it's still thin, add a constarch slurry (mix 1 tablespoon of cornstarch with 1 tablespoon of water and then add to the gravy). Continue heating until gravy thickens to desired consistency.",
    "Once you're happy with the consistency of your gravy, season with salt and pepper to taste and enjoy!"
  ],
  notes: null,
  source: "https://tastesbetterfromscratch.com/turkey-gravy/",
},
{
  name: "Crispy Slow Cooker Corned Beef",
  description: "Slow cooker corned beef with a crisp, browned top — juicy inside with minimal hands-on effort.",
  image: "/images/recipes/corned-beef.jpg",
  prepTime: "5 min",
  cookTime: "9 hr",
  totalTime: "9 hr 5 min",
  servings: 8,
  cuisine: "Irish",
  category: "Beef",
  tags: ["beef", "slow cooker", "st. patrick's day"],
  ingredients: [
    "3 lbs corned beef, with seasoning packet",
    "1 cup water (may need less depending on slow cooker size)",
    "3 cloves garlic, minced",
    "1 bay leaf",
    "2 tbsp sugar",
    "2 tbsp apple cider vinegar",
    "½ tsp ground black pepper",
  ],
  instructions: [
    "Add corned beef, fat side up, to the slow cooker",
    "Add the minced garlic, spice packet, sugar, and pepper to the top of the meat and rub on",
    "Add the vinegar and bay leaf to the side of the corned beef and add just enough water to come up about 25% of the way to the top of the meat",
    "Cook on low for 8-9 hours",
    "If, for some reason, the corned beef is not browned on top (or enough to your liking), put under a broiler (6-7 inches away) for 1-2 minutes. Leave the oven door open a bit so you can look in as this isn't something you can leave unattended.",
  ],
  notes: null,
  source: "https://dinnerthendessert.com/crispy-slow-cooker-corned-beef/",
},
{
  name: "Kalbi (Korean BBQ Short Ribs)",
  description: "Korean-style flanken-cut short ribs marinated in a sweet soy-garlic-pear marinade and grilled fast and hot.",
  image: "/images/recipes/kalbi-short-ribs.jpg",
  prepTime: "20 min",
  cookTime: "8 min",
  totalTime: "4 hr 28 min",
  servings: 6,
  cuisine: "Korean",
  category: "Beef",
  tags: ["beef", "short ribs", "grilling", "marinade"],
  ingredients: [
    "5 lbs Korean-style beef short ribs",
    "1 cup brown sugar, packed",
    "1 cup soy sauce",
    "½ cup water",
    "¼ cup mirin (rice wine)",
    "1 small onion, peeled and finely grated",
    "1 small Asian pear, peeled and finely grated",
    "4 tbsp minced garlic",
    "2 tbsp dark sesame oil",
    "¼ tsp black pepper",
    "2 green onions, thinly sliced (optional)",
  ],
  instructions: [
    "Sprinkle brown sugar over beef and mix well to evenly coat. Let sit at room temperature for 10 minutes while preparing marinade. In a bowl, whisk together remaining ingredients. Transfer beef into a large sealable freezer bag (you may need 2). Add marinade, press out excess air from bag(s), and seal. Turn bag over several times to ensure beef is evenly coated. Refrigerate for at least 4 hours but preferably overnight.",
    "Heat gas or charcoal grill to medium heat. Drain excess marinade off beef. Grill short ribs, turning once, to desired doneness, about 3-4 minutes per side. Garnish with thinly sliced green onions, if desired. Serve whole pieces as a main course or cut into smaller pieces, using kitchen shears, for a starter or party nibble."
  ],
  notes: null,
  source: "https://www.foodnetwork.com/recipes/kalbi-korean-barbequed-beef-short-ribs-recipe-1953236",
},
{
  name: "Karniyarik (Turkish Stuffed Eggplant)",
  description: "Roasted whole eggplants stuffed with a spiced ground beef, tomato, and pepper filling, finished in a light tomato sauce.",
  image: "/images/recipes/karniyarik.jpg",
  prepTime: "30 min",
  cookTime: "50 min",
  totalTime: "1 hr 20 min",
  servings: 5,
  cuisine: "Turkish",
  category: "Beef",
  tags: ["beef", "eggplant", "baked"],
  ingredients: [
    "5 medium eggplants",
    "5 tbsp olive oil",
    "**For filling:**",
    "2 tbsp olive oil",
    "1 small onion, finely chopped",
    "3 cloves garlic, finely chopped",
    "200g/7oz ground beef",
    "¼ cup green pepper, finely chopped",
    "½ cup tomatoes, finely chopped",
    "1 tsp salt",
    "½ tsp black pepper",
    "½ cup fresh parsley, finely chopped",
    "**For sauce:**",
    "1½ cups hot water",
    "2 tbsp tomato paste (replace up to 1 tbsp with acı biber salçası)",
  ],
  instructions: [
    "Preheat the oven to 200°C/400°F",
    "Peel the eggplants lengthwise, leaving some stripes of the skin. Using a knife, make a slit on each eggplant but don't cut it all. Don't remove the stems.",
    "Soak the eggplants in salted water for about 15 minutes. Gently squeeze them and pat dry with a paper towel.",
    "Place the eggplants on an oven grill or on a baking sheet lined with parchment paper. Brush the eggplants with olive oil, about 1 tablespoon olive oil for each. Bake them until tender, for 30 minutes.",
    "Prepare the filling when you put the eggplants in the oven. Heat olive oil in a pan. Cook onions until translucent. Add in garlic and then ground beef. Stir well and press on the ground beef so that there won't be any chunks left.",
    "Then cover the pan and let it release its juice first and then it will absorb most of it.",
    "Now add in chopped peppers and tomatoes. Season with salt and pepper. Let them cook for 5 minutes over low heat.",
    "Remove from heat and add in chopped parsley.",
    "Now remove the eggplants from the oven. Make some space for the filling in each eggplant by pushing the edges of the slit using a spoon. Make a boat shape.",
    "Mix water and tomato paste well and stir most of the tomato sauce mixture into the beef. Stuff the eggplants with the filling and place them in a baking pan.",
    "Bake for 20 minutes",
    "Remove from the oven and garnish with chopped parsely before serving.",
  ],
  notes: null,
  source: "https://www.giverecipe.com/karniyarik/",
},
{
  name: "Pork Medallions with Maple-Balsamic Sauce",
  description: "Seared pork tenderloin medallions in a quick maple-balsamic pan sauce.",
  image: "/images/recipes/maple-balsamic-pork-chops.jpg",
  prepTime: "10 min",
  cookTime: "20 min",
  totalTime: "30 min",
  servings: 4,
  cuisine: "American",
  category: "Pork",
  tags: ["pork", "tenderloin", "quick", "weeknight"],
  ingredients: [
    "**For the sauce:**",
    "½ cup real maple syrup",
    "6 tbsp balsamic vinegar",
    "¼ tsp red pepper flakes",
    "4 tsp Dijon mustard",
    "4 green onions, choppped into small pieces",
    "**For the pork chops:**",
    "4 pork chops",
    "2 tsp vegetable oil",
    "salt",
    "pepper",
    "garlic powder",
  ],
  instructions: [
    "Combine the maple syrup, vinegar, and red pepper flakes in a small saucepan. Turn the heat to medium-high and boil for about 3 minutes, until the mixture has reduced to a thick syrupy consistency. Turn off the heat and whisk in the Dijon mustard & green onions",
    "Meanwhile, place the pork chops on a cutting board (one or two at a time), place a piece of plastic wrap on top, and pound them with a meat mallet or other heavy implement until they are about 1/2\" thick. Do this with all the pork chops",
    "After the pork chops have been pounded, add salt, pepper, and garlic powder to both sides",
    "Heat a pan over medium heat. Add one tablespoon of the vegetable oil and add the prok chops. Cook the pork chops approximately 4 minutes per side. After cooking on both sides (about 8 minutes). Continue to cook, occasionally flipping the pork chops until they reach 145°F. Do not cover. After the pork chops have come to temp, take them out of the pan and set aside",
    "Serve the pork chops with the sauce poured over the top",
  ],
  notes: null,
  source: "https://thewanderlustkitchen.com/easy-pork-medallions-maple-balsamic-sauce/",
},
{
  name: "Honey Garlic Pork Chops",
  description: "Seared pork chops in a quick sweet-savory honey garlic pan sauce, finished under the broiler.",
  image: "/images/recipes/honey-garlic-pork-chops.jpg",
  prepTime: "10 min",
  cookTime: "12 min",
  totalTime: "22 min",
  servings: 4,
  cuisine: "American",
  category: "Pork",
  tags: ["pork", "quick", "weeknight"],
  ingredients: [
    "4 pork chops (bone-in or boneless)",
    "Salt and pepper, to taste",
    "1 tsp garlic powder",
    "2 tbsp olive oil",
    "1 tbsp unsalted butter",
    "6 cloves garlic, minced",
    "¼ cup honey",
    "¼ cup water (or chicken broth)",
    "2 tbsp rice wine vinegar (or apple cider vinegar)",
  ],
  instructions: [
    "Preheat oven broiler (or grill) on medium-high heat. Season chops with salt, pepper, and garlic powder just before cooking.",
    "Heat oil in a pan or skillet over medium high heat until hot. Sear chops on both sides until golden and cooked through (about 4-5 minutes each side). Transfer to a plate, set aside.",
    "Reduce heat to medium. Melt butter in the same pan, scraping up any browned bits from the bottom of the pan. Saute garlic until fragrant (about 30 seconds). Add the honey, water, and vinegar. Increase heat to medium-high and continue to cook until the sauce reduces down and thickens slightly (about 3-4 minutes), while stirring occasionally.",
    "Add pork back into the pan, baste generously with the sauce and broil/grill for 1-2 minutes, or until edges are slightly charred.",
    "Garnish with parsley and serve over vegetables, rice, pasta, or with a salad.",
  ],
  notes: null,
  source: "https://cafedelites.com/easy-honey-garlic-pork-chops/",
},
{
  name: "Slow Cooker Chicken Chili",
  description: "A mildly spiced, creamy slow cooker chicken chili with black beans and corn — no pre-cooking required.",
  image: "/images/recipes/slow-cooker-chicken-chili.jpg",
  prepTime: "10 min",
  cookTime: "8 hr",
  totalTime: "8 hr 10 min",
  servings: 10,
  cuisine: "American",
  category: "Soups",
  tags: ["chicken", "chili", "slow cooker", "soup"],
  ingredients: [
    "2 (14 oz) cans petite diced tomatoes, drained",
    "2 (7 or 8 oz) cans tomato sauce",
    "2 large boneless, skinless chicken breasts (about 1.5 lbs)",
    "1 cup chicken broth",
    "½ cup diced yellow onion",
    "1 large green bell pepper, chopped",
    "1 (14 oz) can corn, drained",
    "1 (14 oz) can black beans, drained and rinsed",
    "1 jalapeño, minced",
    "1 tsp salt",
    "2 tsp dried oregano (or Italian seasoning)",
    "2 tsp chili powder",
    "1 tbsp ground cumin",
    "1 tbsp minced garlic",
    "4 oz cream cheese, room temperature",
  ],
  instructions: [
    "Add all the ingredients except the cream cheese to a 4 quart or larger slow cooker. Give everything a big stir. Cook on low for 6-7 hours or on high for 3 hours.",
    "Remove the chicken and chop into bite-sized pieces or use two forks to shred it. Return chicken to the slow cooker and add the cream cheese. Stir everything together until the cream cheese has melted. Taste, then add more salt or seasonings if desired. I usually add a little more chili powder and dried oregano/italian seasoning blend. Cover the slow cooker and cook for about 10-15 more minutes",
  ],
  notes: null,
  source: "https://sallysbakingaddiction.com/my-favorite-slow-cooker-chicken-chili-recipe/",
},
{
  name: "Herbed Chicken with Beets and Brussels Sprouts",
  description: "A whole chicken slow-cooked over celery, onion, and root vegetables, with a simple mustard pan sauce made from the cooking juices.",
  image: "/images/recipes/herbed-chicken.jpg",
  prepTime: "20 min",
  cookTime: "8 hr",
  totalTime: "8 hr 20 min",
  servings: 6,
  cuisine: "American",
  category: "Chicken",
  tags: ["chicken", "slow cooker", "one-pot", "root vegetables"],
  ingredients: [
    "1 tbsp kosher salt",
    "2 tsp paprika",
    "1½ tsp dried thyme",
    "1 tsp freshly ground pepper",
    "1 whole chicken",
    "1 lemon",
    "1 large celery rib",
    "1 red onion",
    "4 cloves garlic",
    "½ lb baby carrots",
    "¾ lb small assorted beets",
    "12 large Brussels sprouts",
    "1½ tsp Dijon mustard",
    "Fresh rosemary leaves, for garnish",
  ],
  instructions: [
    "Stir together first 4 ingredients. Remove and discard neck and giblets from chicken. Sprinkle chicken with salt mixture. Place lemon into cavity of chicken. Tie legs together with kitchen string, and tuck wingtips under.",
    "Place celery, onion, and garlic in a single layer in a lightly greased 6-quart slow cooker. Place chicken on top of onions, breast side up. Arrange and tuck remaining vegetables around chicken. Sprinkle vegetables with any remaining salt mixture.",
    "Cover and cook on low 8 hours or until done. Remove chicken to a serving dish. Rub skins from beets and cut into quarters; arrange with other vegetables around chicken. Garnish with rosemary. Whisk mustard into remianing cooking juices in slow cooker; season with salt and pepper to taste. Serve sauce with chicken.",
  ],
  notes: null,
  source: "https://www.countryliving.com/food-drinks/recipes/a5689/herbed-chicken-beets-brussels-recipe-clx1014/",
},
{
  name: "Broccoli Chicken Twist",
  description: "Shredded chicken, broccoli, and cheddar wrapped in a braided crescent dough crust.",
  image: null,
  prepTime: "25 min",
  cookTime: "25 min",
  totalTime: "50 min",
  servings: 10,
  cuisine: "American",
  category: "Chicken",
  tags: ["chicken", "broccoli", "baked", "crescent dough", "party food"],
  ingredients: [
    "2 cups cooked chicken, chopped",
    "½ cup diced red bell pepper",
    "1 clove garlic, pressed",
    "2 tsp dried dill or 1 tsp dill weed",
    "1 cup chopped broccoli",
    "1 cup sharp cheddar cheese",
    "½ cup mayonnaise",
    "¼ tsp salt",
    "2 (8 oz) packages refrigerated crescent roll dough",
    "2 tbsp slivered almonds",
    "1 egg white, lightly beaten",
  ],
  instructions: [
    "Mix together all ingredients except crescent rolls, egg white, & almonds",
    "Unroll rolls without separating. Lay crescent roll sheets next to each other (long sides together) on a baking sheet",
    "Spread filling on top, then lift and twist strips together - pairing long sides with the opposite \"tip\" ([reference image](https://i.imgur.com/K6TXY3n.png))",
    "Brush on egg white & sprinkle almonds",
    "Bake for 25 minutes, until golden brown",
  ],
  notes: null,
  source: null,
},
{
  name: "Fried Rice",
  description: "A quick egg fried rice made from day-old rice — a great way to use up leftovers.",
  image: "/images/recipes/fried-rice.jpg",
  prepTime: "2 min",
  cookTime: "8 min",
  totalTime: "10 min",
  servings: 2,
  cuisine: "Chinese",
  category: "Sides",
  tags: ["rice", "eggs", "quick", "leftovers", "weeknight"],
  ingredients: [
    "3 cups cooked rice (we prefer calrose rice)",
    "2 large eggs, beaten",
    "1 tsp salt",
    "4 tbsp vegetable oil",
    "2 tbsp soy sauce",
    "½ cup peas",
    "¼ cup chopped carrots",
    "2 green onions, finely chopped",
    "1 tsp sesame oil",
  ],
  instructions: [
    "Cook rice (if not done already)",
    "Add oil to a large pan or wok, add rice, cook on medium for 3 minutes",
    "Add soy sauce & salt. Mix.",
    "Add carrots, green onion, peas, & sesame oil. Cook for 5 minutes or until carrots are tender.",
    "Add beaten eggs to rice. Stir around and cook until eggs are done *(note: we prefer the raw egg mixed into the rice as it cooks, which acts more as a \"binder\" for the rice rather than the traditional \"small pieces of scrambled egg\" that is usually in fried rice)*",
  ],
  notes: "Add in cooked shrimp or other protein at step 4 for a more hearty meal",
  source: null,
},
{
  name: "Cinnamon Apple Pork Chops",
  description: "Pan-seared pork chops topped with a warm cinnamon-apple-pecan sauté — an easy fall dinner.",
  image: "/images/recipes/cinnamon-apple-pork-chops.jpg",
  prepTime: "8 min",
  cookTime: "20 min",
  totalTime: "28 min",
  servings: 4,
  cuisine: "American",
  category: "Pork",
  tags: ["pork", "apples", "fall", "skillet", "quick"],
  ingredients: [
    "4 boneless pork loin chops (4 oz each)",
    "2 tbsp reduced-fat butter, divided",
    "2-3 tbsp brown sugar, to taste",
    "1 tsp ground cinnamon",
    "½ tsp ground nutmeg",
    "¼ tsp salt",
    "4 medium tart apples, thinly sliced",
    "2 tbsp chopped pecans",
  ],
  instructions: [
    "Cook the pork chops in 1 tbsp of the butter over medium heat, 4-5 minutes per side, until a meat thermometer reads 160°F.",
    "While the chops cook, combine the brown sugar, cinnamon, nutmeg, and salt in a small bowl.",
    "Remove the chops from the pan and keep them warm.",
    "Add the apples, pecans, brown sugar mixture, and remaining butter to the same pan; cook and stir until the apples are tender.",
    "Spoon the apple mixture over the chops and serve.",
  ],
  notes: "",
  source: null,
},
{
  name: "Frittata",
  description: "A flexible master frittata recipe — whisked eggs baked with cheese and vegetables, adaptable to a full frittata, a casserole, or mini muffin-cup versions.",
  image: "/images/recipes/frittata.jpg",
  prepTime: "20 min",
  cookTime: "25 min",
  totalTime: "45 min",
  servings: 8,
  cuisine: "Italian",
  category: "Breakfast",
  tags: ["eggs", "breakfast", "vegetarian", "make-ahead", "gluten-free"],
  ingredients: [
    "12 eggs",
    "3 tbsp full-fat dairy (heavy cream, half-and-half, whole milk, sour cream, crème fraîche, or yogurt)",
    "½ tsp salt",
    "1 cup (4 oz) grated or crumbled cheese",
    "3-5 cups chopped vegetables or greens (or 3 cups cooked leftovers)",
    "1 tbsp olive oil",
    "Fresh herbs, for garnish (basil, parsley, cilantro, or dill)",
  ],
  instructions: [
    "Preheat the oven to 425°F for the stovetop-finished method, or 350°F if baking the whole thing in the oven.",
    "Whisk the eggs with the dairy and salt, then stir in the cheese.",
    "Warm the olive oil in a skillet and sauté the vegetables until tender; season lightly.",
    "For a stovetop frittata: pour the egg mixture over the vegetables in an oven-safe skillet, let the edges set on the stove, then transfer to the oven and bake 7-14 minutes.",
    "For a casserole: let the cooked vegetables cool slightly, mix with the egg mixture, pour into a greased 9x13 pan, and bake 20-25 minutes.",
    "For mini frittatas: divide the mixture among greased muffin cups and bake 13-17 minutes.",
    "However you make it, bake until puffed with just a slight jiggle in the center, then garnish with fresh herbs before serving.",
  ],
  notes: "Don't overcook — it turns dry and eggy. Pre-cook your vegetables first; raw ones release too much water into the eggs. Stick to full-fat dairy for the creamiest texture. Keeps refrigerated for several days, but doesn't freeze well.",
  source: "https://cookieandkate.com/best-frittata-recipe/",
},
{
  name: "Menemen",
  description: "Turkish-style soft scrambled eggs cooked with tomatoes, peppers, and onion — a one-pan dish good for any meal.",
  image: "/images/recipes/menemen.jpg",
  prepTime: "10 min",
  cookTime: "15 min",
  totalTime: "25 min",
  servings: 4,
  cuisine: "Turkish",
  category: "Breakfast",
  tags: ["eggs", "one-pan", "quick", "vegetarian"],
  ingredients: [
    "2 tbsp extra virgin olive oil",
    "1 medium yellow onion, chopped",
    "1 green bell pepper, cored, seeded, and chopped",
    "Kosher salt, to taste",
    "2 vine-ripe tomatoes, chopped",
    "3 tbsp tomato paste",
    "Black pepper, to taste",
    "½ tsp dried oregano",
    "1 tsp Aleppo pepper",
    "4 large eggs, beaten",
    "Crushed red pepper flakes, optional",
    "1 French baguette, for serving (optional)",
  ],
  instructions: [
    "Sauté the onion and bell pepper with a pinch of salt in a 10-inch skillet over medium heat for 4-5 minutes, until softened.",
    "Add the tomatoes, tomato paste, black pepper, oregano, and Aleppo pepper, and cook 5-7 minutes until the tomatoes soften.",
    "Push the mixture to one side of the pan, reduce the heat to medium-low, and pour in the beaten eggs; cook gently until just set.",
    "Gently fold the tomato mixture into the eggs without overmixing.",
    "Remove from the heat, drizzle with olive oil and a little extra Aleppo pepper or red pepper flakes, and serve right away with crusty bread.",
  ],
  notes: "Cook the eggs low and slow so they stay soft and just set rather than firm — that's the whole point of menemen. Good crusty bread for dipping makes it complete.",
  source: "https://www.themediterraneandish.com/menemen-recipe/",
},
{
  name: "Cinnamon French Toast Sticks",
  description: "Classic French toast cut into dippable sticks, coated in a cinnamon-vanilla custard.",
  image: "/images/recipes/french-toast-sticks.jpg",
  prepTime: "10 min",
  cookTime: "10 min",
  totalTime: "20 min",
  servings: 4,
  cuisine: "American",
  category: "Breakfast",
  tags: ["french toast", "breakfast", "kid-friendly", "make-ahead"],
  ingredients: [
    "8 slices Texas toast bread (or brioche, challah, or similar)",
    "4 large eggs",
    "1 cup whole milk, half-and-half, or cream",
    "1 tbsp vanilla extract",
    "3 tbsp sugar",
    "2 tsp cinnamon",
    "Pinch of salt",
    "3-4 tbsp butter",
    "Powdered sugar, for topping",
    "Maple syrup, for serving",
  ],
  instructions: [
    "Whisk together the eggs, milk, vanilla, sugar, cinnamon, and salt in a bowl.",
    "Cut each slice of bread into thirds (into stick shapes).",
    "Melt the butter in a skillet over medium heat.",
    "Dip the bread sticks in the egg mixture until coated, then place in the skillet without crowding.",
    "Cook each side until golden brown, about 3-4 minutes per side, then transfer to a plate.",
    "Dust with powdered sugar and serve with maple syrup.",
  ],
  notes: "Day-old or slightly stale bread soaks up the custard better than fresh. Try swapping in almond extract, citrus zest, or pumpkin spice for the vanilla/cinnamon. Freezes well for up to 2 months — reheat frozen sticks at 350°F for about 8 minutes. The custard can be mixed up to 24 hours ahead.",
  source: "https://www.lemonblossoms.com/blog/cinnamon-french-toast-sticks/",
},
{
  name: "French Toast Casserole",
  description: "A make-ahead baked French toast casserole with a cinnamon-brown sugar syrup baked right into the bread.",
  image: "/images/recipes/french-toast-casserole.jpg",
  prepTime: "15 min",
  cookTime: "45 min",
  totalTime: "1 hr",
  servings: 9,
  cuisine: "American",
  category: "Breakfast",
  tags: ["french toast", "casserole", "make-ahead", "brunch"],
  ingredients: [
    "½ cup unsalted butter",
    "1¼ cups packed light brown sugar, divided",
    "1 loaf thick-sliced bread, cut into 2-inch slices",
    "6 large eggs",
    "2 cups milk",
    "2 tbsp pure vanilla extract",
    "2 tsp ground cinnamon",
    "½ tsp ground nutmeg",
    "Powdered sugar, for dusting",
    "Fresh berries or fruit, for serving (optional)",
  ],
  instructions: [
    "Grease a 9x13-inch baking dish.",
    "Melt the butter, mix with 1 cup of the brown sugar, and spread evenly over the bottom of the dish.",
    "Whisk together the eggs, milk, and vanilla until smooth.",
    "Combine the remaining brown sugar with the cinnamon and nutmeg.",
    "Layer half the bread over the sugar base, pour over half the egg mixture, and sprinkle with half the spiced sugar; repeat with the remaining bread, egg mixture, and spiced sugar, pressing down gently.",
    "Cover and refrigerate for at least 30 minutes, ideally overnight.",
    "Let the dish sit at room temperature for 20 minutes, then bake covered at 350°F for 30 minutes.",
    "Uncover and bake 15 minutes more, until golden and set. Dust with powdered sugar before serving.",
  ],
  notes: "Slightly stale bread holds up better and soaks in the syrup more evenly — press it down gently as you layer. Keep it covered for the first bake so it doesn't brown too fast; check doneness with a knife in the center, it should come out mostly clean.",
  source: "https://cafedelites.com/french-toast-casserole/",
},
{
  name: "Easy Chicken Rice Soup",
  description: "A well-balanced chicken and rice soup loaded with vegetables and tender shredded chicken.",
  image: "/images/recipes/chicken-and-rice-soup.jpg",
  prepTime: "10 min",
  cookTime: "45 min",
  totalTime: "55 min",
  servings: 4,
  cuisine: "American",
  category: "Soups",
  tags: ["chicken", "soup", "rice", "comfort food"],
  ingredients: [
    "1 tbsp olive oil",
    "1 onion, diced",
    "3 carrots, peeled and diced",
    "3 stalks celery, sliced",
    "2 cloves garlic, minced",
    "1 tsp dried thyme",
    "1 bay leaf",
    "2 boneless, skinless chicken breasts",
    "1 cup long-grain white rice (basmati or jasmine)",
    "4 cups chicken or vegetable broth",
    "4 cups water",
    "½ tsp sea salt",
    "¼ tsp black pepper",
    "Fresh parsley, for serving",
  ],
  instructions: [
    "Warm the oil in a large pot and sauté the onion, carrots, and celery until tender, 4-5 minutes.",
    "Stir in the garlic, thyme, salt, and pepper, and cook briefly until fragrant.",
    "Add the rice, broth, water, and bay leaf, and stir to combine.",
    "Submerge the raw chicken breasts in the broth, cover, and simmer for 30 minutes.",
    "Remove the chicken and shred it into bite-sized pieces on a cutting board.",
    "Return the shredded chicken to the pot along with the parsley, and simmer 5 minutes more.",
    "Season to taste and serve.",
  ],
  notes: "Also works in a slow cooker (3-4 hours on high or 5-6 on low) or an Instant Pot (5 minutes at high pressure). Leftover cooked chicken or rice can be substituted — just add them near the end so they don't overcook. Freezes well for up to 3 months.",
  source: "https://kaynutrition.com/easy-chicken-rice-soup/",
},
{
  name: "Ultra-Satisfying Chicken Noodle Soup",
  description: "A hearty, from-scratch chicken noodle soup built on a simple mirepoix and simmered chicken thighs.",
  image: null,
  prepTime: "15 min",
  cookTime: "30 min",
  totalTime: "45 min",
  servings: 6,
  cuisine: "American",
  category: "Soups",
  tags: ["chicken", "soup", "noodles", "comfort food"],
  ingredients: [
    "1 lb boneless, skinless chicken thighs (4-5 thighs)",
    "5 oz egg noodles or pasta",
    "2 tbsp butter, chicken fat, or olive oil",
    "1 large onion, chopped",
    "2 large carrots, chopped",
    "2 stalks celery, chopped (optional)",
    "1 heaping tbsp minced garlic (about 4 cloves)",
    "2 bay leaves",
    "3 sprigs fresh thyme (or ½ tsp dried)",
    "8 cups low-sodium chicken stock or broth",
    "Salt and pepper, to taste",
    "¼ cup fresh parsley, finely chopped",
    "Water or additional stock, as needed",
  ],
  instructions: [
    "Sauté the onion, carrots, and celery in the butter until softened.",
    "Add the garlic, bay leaves, and thyme, and cook briefly until fragrant.",
    "Pour in the stock, bring to a simmer, and season with salt and pepper.",
    "Submerge the chicken thighs in the broth and simmer about 20 minutes, until cooked through.",
    "Add more stock or water if the liquid level has dropped too low.",
    "Add the noodles directly to the soup and cook until tender.",
    "Shred the chicken, return it to the pot, adjust the seasoning, stir in the parsley, and serve.",
  ],
  notes: "",
  source: "https://cooked.wiki/saved/116ef8fb-ecab-40b8-9981-cd5c00d7c6ec",
},
{
  name: "Dairy-Free Chicken Corn Chowder",
  description: "A creamy, dairy-free and gluten-free corn chowder thickened with blended potatoes and coconut milk instead of cream and flour.",
  image: "/images/recipes/dairy-free-chicken-corn-chowder.jpg",
  prepTime: "15 min",
  cookTime: "40 min",
  totalTime: "55 min",
  servings: 6,
  cuisine: "American",
  category: "Soups",
  tags: ["chicken", "corn", "chowder", "dairy-free", "gluten-free", "soup"],
  ingredients: [
    "4 ears corn, shucked and steamed",
    "2 large red potatoes, peeled and chopped",
    "3 tbsp avocado oil",
    "1 large yellow onion, chopped",
    "3 cloves garlic, minced",
    "2 cups carrots, peeled and chopped",
    "3 stalks celery, chopped",
    "1 large red bell pepper, cored and chopped",
    "1½ tsp sea salt",
    "2 tsp Cajun seasoning",
    "¼ tsp ground cumin",
    "⅔ cup full-fat canned coconut milk",
    "2 cups water",
    "2 large chicken breasts, chopped",
    "4 strips thick-cut bacon, cooked and chopped",
  ],
  instructions: [
    "Boil the corn and potatoes separately until cooked through.",
    "Sauté the onion, then add the remaining vegetables along with the salt, Cajun seasoning, and cumin.",
    "Blend half the corn and one of the cooked potatoes with the coconut milk and water until smooth.",
    "Combine the blended mixture with the sautéed vegetables, the remaining potato, and the chopped chicken.",
    "Simmer 20-30 minutes, until the chicken is cooked through.",
    "Cook the bacon separately and chop it.",
    "Adjust the salt to taste and serve topped with the chopped bacon.",
  ],
  notes: "Canned or frozen corn works if fresh isn't in season. Leftover cooked chicken is a fine substitute for raw. The blended potato and coconut milk are what give this its creaminess without any dairy.",
  source: "https://www.theroastedroot.net/dairy-free-chicken-corn-chowder/",
},
{
  name: "Liège Belgian Waffles with Pearl Sugar",
  description: "Rich, chewy Belgian waffles made from an enriched yeasted dough studded with pearl sugar that caramelizes on the iron.",
  image: "/images/recipes/liege-waffles.jpg",
  prepTime: "50 min",
  cookTime: "20 min",
  totalTime: "1 hr 10 min",
  servings: 10,
  cuisine: "Belgian",
  category: "Breakfast",
  tags: ["waffles", "yeasted", "breakfast", "pearl sugar"],
  ingredients: [
    "1 (.25 oz) package active dry yeast",
    "1½ tbsp white sugar",
    "¾ cup lukewarm milk (no more than 100°F)",
    "3 large eggs",
    "1 cup melted butter",
    "2 tsp vanilla extract",
    "3 cups flour",
    "½ tsp salt",
    "1½ cups pearl sugar",
  ],
  instructions: [
    "Sprinkle the yeast and white sugar over the warm milk in a small bowl and let it sit about 15 minutes, until foamy.",
    "Whisk the eggs, melted butter, and vanilla into the yeast mixture until combined.",
    "In a separate large bowl, stir together the flour and salt and make a well in the center. Pour in the egg mixture and stir until a soft dough forms.",
    "Cover and let rise in a warm spot (80-95°F) until doubled, about 30 minutes, then gently fold in the pearl sugar.",
    "Preheat a waffle iron according to the manufacturer's instructions.",
    "Portion out baseball-sized balls of dough onto the hot iron and cook until golden and crisp, about 2 minutes each. Let cool 2-3 minutes before serving.",
  ],
  notes: "The pearl sugar is what gives these their signature caramelized crunch — look for it near the baking aisle or at specialty grocers (Lars' Own is a common brand). Best served warm, plain or with a light dusting of powdered sugar.",
  source: "https://www.allrecipes.com/recipe/213251/liege-belgian-waffles-with-pearl-sugar/",
}];
